module.exports = __webpack_public_path__ + "media/images/background-5-ded48ff0ca67c32994592a4dea8f06f5.svg";